import PropTypes from 'prop-types';
import { useEffect, useCallback, useState } from 'react';
// routes
import { paths } from 'src/routes/paths';
import { useRouter } from 'src/routes/hooks';
//
import { useSelector } from 'react-redux';


// ----------------------------------------------------------------------

const loginPaths = {
  jwt: paths.auth.jwt.login,
  auth0: paths.auth.auth0.login,
  amplify: paths.auth.amplify.login,
  firebase: paths.auth.firebase.login,
};

// ----------------------------------------------------------------------

export default function AuthGuard({ children }) {
  const router = useRouter();
  const {user}= useSelector((state) => state.user);
  const [checked, setChecked] = useState(false);
  const check = useCallback(() => {
    if (!user?.accesstoken) {
      console.log('AuthGuard: No user token found');
      router.push('/');
    } else {
      console.log('AuthGuard: User token found');
      setChecked(true);
    }
  }, [user, router]);


  useEffect(() => {
    check();
  }, []);

  if (!checked) {
    return null;
  }

  return <>{children}</>;
}

AuthGuard.propTypes = {
  children: PropTypes.node,
};
